import { Route } from "@/types/collections"

/** "1 route" / "3 routes" - used in the map pin cards. */
export function formatRouteCount(count: number) {
  return `${count} ${count === 1 ? "route" : "routes"}`
}

/** Dedupe the route list behind a pin - the same route can own several stops at one location. */
export function uniqueRoutesFrom(entries: { route: Route }[]): Route[] {
  return Array.from(new globalThis.Map(entries.map((e) => [e.route.id, e.route])).values())
}
